/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_TitleInputs */

const en_mcp_demo_title = /** @type {(inputs: Mcp_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One message, and it's in your library`)
};

const es_mcp_demo_title = /** @type {(inputs: Mcp_Demo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mensaje y ya está en tu biblioteca`)
};

/**
* | output |
* | --- |
* | "One message, and it's in your library" |
*
* @param {Mcp_Demo_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_title = /** @type {((inputs?: Mcp_Demo_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_title(inputs)
	return en_mcp_demo_title(inputs)
});